import React from "react";

export default function Section3() {
  const reasons = [
    {
      title: " Discovery",
      description: "We analyze business goals, current ecommerce setup, and growth plans to create a custom Shopify Plus solution for enterprise needs.",
    },
    {
      title: "Design",
      description: " Wireframes and interfaces are conversion-focused and tailored for scalability.",
    },
    {
      title: "Development",
      description: " We implement high-performance, enterprise-level storefronts with advanced Shopify Plus functionality.",
    },
    {
      title: "Testing",
      description: "Thorough testing across devices, browsers, and performance metrics ensures enterprise-grade reliability.",
    },
    {
      title: " Launch and Growth Support",
      description: "Post-launch, we provide continuous monitoring, feature enhancements, and performance optimization for long-term success.",
    },
  ];

  return (
    <div className="w-full Section12">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
           Our Shopify Plus Development Process

        </h2>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {reasons.map((item, index) => (
            <div
              key={index}
              className={`p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px] ${
                index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              }`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {item.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
